var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__section__wrap"},[_c('div',{staticClass:"form__section--left"},[_c('mailing-lists-column',{attrs:{"mailing-lists":_vm.leftMailingLists,"data":_vm.data},on:{"change":_vm.handleChange}})],1),_vm._v(" "),_c('div',{staticClass:"form__section--right"},[_c('mailing-lists-column',{attrs:{"mailing-lists":_vm.rightMailingLists,"data":_vm.data},on:{"change":_vm.handleChange}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7742ed79","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MailingLists.vue
// module id = 156
// module chunks = 0